import { render, staticRenderFns } from "./CreateContentLesson.vue?vue&type=template&id=82c6dee6"
import script from "./CreateContentLesson.vue?vue&type=script&lang=js"
export * from "./CreateContentLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports